module.exports = __webpack_public_path__ + "media/images/oyako_no_kufu-8a8d301f29b4f2c430a1fff2b014d8ec.png";